import { createTheme } from '@mui/material';
import ProximaNovaRegular from '../assets/fonts/ProximaNova-Regular.otf';

const globalTheme = createTheme({
  typography: {
    fontFamily: 'Proxima Nova',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': {
          fontFamily: 'Proxima Nova',
          src: `url(${ProximaNovaRegular}) format('opentype')`,
        },
      },
    },
  },
});

export default globalTheme;
